module.exports = __webpack_public_path__ + "img/document.22a5fac6.svg";